(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqNav extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-faq-pill]'));
      this.categories = Array.from(this.querySelectorAll('[data-faq-category]'));

      this.pills.forEach((pill) => {
        pill.addEventListener('click', (event) => {
          event.preventDefault();
          const target = this.querySelector('#' + CSS.escape(pill.dataset.target));
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            this.setActivePill(pill);
          }
        });
      });

      if (this.categories.length && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const pill = this.pills.find((p) => p.dataset.target === entry.target.id);
                if (pill) this.setActivePill(pill);
              }
            });
          },
          { rootMargin: '-20% 0px -70% 0px' }
        );
        this.categories.forEach((category) => this.observer.observe(category));
      }

      if (this.pills.length) this.setActivePill(this.pills[0]);
    }

    setActivePill(activePill) {
      this.pills.forEach((pill) => pill.classList.toggle('is-active', pill === activePill));
    }
  }

  customElements.define('faq-nav', FaqNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.menuDialog = this.querySelector('#site-menu-dialog');
      this.menuToggle = this.querySelector('[data-menu-toggle]');
      this.searchToggle = this.querySelector('[data-search-toggle]');
      this.searchPanel = this.querySelector('#site-search-panel');
      this.cartDialog = this.querySelector('#cart-drawer');
      this.cartToggles = this.querySelectorAll('[data-cart-toggle]');

      this.menuToggle?.addEventListener('click', () => {
        this.menuDialog.showModal();
      });

      this.searchToggle?.addEventListener('click', () => {
        const isOpen = this.searchPanel.classList.toggle('is-open');
        this.searchToggle.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) {
          this.searchPanel.querySelector('input')?.focus();
        }
      });

      this.cartToggles.forEach((toggle) => {
        toggle.addEventListener('click', (event) => {
          if (!this.cartDialog) return;
          event.preventDefault();
          this.menuDialog?.close();
          this.cartDialog.showModal();
        });
      });

      // Cerrar los drawers al hacer clic en el fondo (backdrop)
      this.menuDialog?.addEventListener('click', (event) => {
        if (event.target === this.menuDialog) {
          this.menuDialog.close();
        }
      });

      this.cartDialog?.addEventListener('click', (event) => {
        if (event.target === this.cartDialog) {
          this.cartDialog.close();
        }
      });

      // Cuando algo agrega productos al carrito en cualquier parte del sitio
      // (ej. la página de producto), abrimos el drawer automáticamente.
      document.addEventListener('cart:open', () => {
        this.cartDialog?.showModal();
      });
    }
  }

  customElements.define('site-header', SiteHeader);

  /**
   * <cart-items> — maneja cantidad, quitar y notas del carrito, y se
   * re-renderiza a sí mismo (y a cualquier otro <cart-items> presente,
   * ej. el de la página /cart) vía la Section Rendering API de Shopify
   * cada vez que el carrito cambia, sin recargar la página.
   */
  class CartItems extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));

      this.noteField = this.querySelector('[data-cart-note]');
      this.noteField?.addEventListener('change', (event) => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: event.target.value }),
        });
      });

      // Se dispara desde cualquier otro componente (ej. tarjeta de producto)
      // después de agregar algo al carrito, para que este cart-items se
      // ponga al día sin tener que volver a interactuar con él.
      document.addEventListener('cart:items:refresh', () => this.refreshAll());
    }

    onClick(event) {
      const qtyBtn = event.target.closest('[data-quantity-change]');
      const removeBtn = event.target.closest('[data-remove-item]');

      if (qtyBtn) {
        event.preventDefault();
        const line = qtyBtn.dataset.line;
        const delta = parseInt(qtyBtn.dataset.quantityChange, 10);
        const valueEl = this.querySelector(`[data-quantity-input="${line}"]`);
        const current = valueEl ? parseInt(valueEl.textContent, 10) : 0;
        this.updateLine(line, Math.max(0, current + delta));
        return;
      }

      if (removeBtn) {
        event.preventDefault();
        this.updateLine(removeBtn.dataset.line, 0);
      }
    }

    updateLine(line, quantity) {
      this.markAllLoading(true);
      this.pendingStockMessage = null;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) {
            this.pendingStockMessage = { line, text: data.message || data.description || 'No hay más disponibles' };
          } else if (quantity > 0) {
            const item = data.items[Number(line) - 1];
            if (item && item.quantity < quantity) {
              this.pendingStockMessage = { line, text: 'No hay más disponibles' };
            }
          }
          return this.refreshAll();
        })
        .catch(() => this.markAllLoading(false));
    }

    markAllLoading(isLoading) {
      document.querySelectorAll('cart-items[data-section-id]').forEach((el) => {
        el.classList.toggle('is-loading', isLoading);
      });
    }

    refreshAll() {
      const allCartItems = document.querySelectorAll('cart-items[data-section-id]');
      const ids = [...new Set(Array.from(allCartItems).map((el) => el.dataset.sectionId))];
      if (!ids.length) return Promise.resolve();

      const rootUrl = document.querySelector('site-header')?.dataset.rootUrl || '/';
      const base = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';

      return fetch(`${base}?sections=${ids.join(',')}`)
        .then((response) => response.json())
        .then((sections) => {
          allCartItems.forEach((el) => {
            const html = sections[el.dataset.sectionId];
            if (!html) return;
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const fresh = parsed.querySelector('cart-items');
            if (fresh) el.innerHTML = fresh.innerHTML;
          });
          document.dispatchEvent(new CustomEvent('cart:updated'));
          this.showPendingStockMessage();
        })
        .finally(() => this.markAllLoading(false));
    }

    showPendingStockMessage() {
      if (!this.pendingStockMessage) return;
      const { line, text } = this.pendingStockMessage;
      this.pendingStockMessage = null;

      const valueEl = this.querySelector(`[data-quantity-input="${line}"]`);
      const lineEl = valueEl?.closest('.cart-line');
      if (!lineEl) return;

      let message = lineEl.querySelector('.cart-line__stock-message');
      if (!message) {
        message = document.createElement('p');
        message.className = 'cart-line__stock-message';
        lineEl.querySelector('.cart-line__info')?.appendChild(message);
      }
      message.textContent = text;
      window.setTimeout(() => message?.remove(), 3000);
    }
  }

  customElements.define('cart-items', CartItems);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants-json]').textContent);
      this.mainImage = this.querySelector('[data-main-image]');
      this.setupZoom();
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.addLabel = this.querySelector('[data-add-to-cart-label]');
      this.priceEl = this.querySelector('[data-price]');
      this.stockEl = this.querySelector('[data-stock]');
      this.stockCountEl = this.querySelector('[data-stock-count]');
      this.qtyValueEl = this.querySelector('[data-qty-value]');
      this.noticeEl = this.querySelector('[data-selection-notice]');
      this.quantity = 1;
      const initialVariant = this.variants.find((v) => String(v.id) === this.addButton?.dataset.variantId);
      this.maxQuantity = initialVariant && initialVariant.inventoryManagement === 'shopify'
        ? Math.max(initialVariant.inventoryQuantity, 1)
        : null;

      this.querySelectorAll('[data-qty-change]').forEach((btn) => {
        btn.addEventListener('click', () => this.changeQuantity(Number(btn.dataset.qtyChange)));
      });

      this.selectedOptions = [];
      const activePills = this.querySelectorAll('.product-info__option-pill.is-active');
      activePills.forEach((pill) => {
        this.selectedOptions[Number(pill.dataset.optionIndex)] = pill.dataset.optionValue;
      });

      // Galería: miniaturas
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.selectThumb(thumb));
      });

      // Galería: flechas — cambian de imagen (a la anterior/siguiente), no solo hacen scroll
      this.querySelectorAll('[data-thumb-scroll]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!this.thumbs.length) return;
          const currentIndex = this.thumbs.findIndex((t) => t.classList.contains('is-active'));
          const direction = Number(btn.dataset.thumbScroll);
          let nextIndex = (currentIndex === -1 ? 0 : currentIndex) + direction;
          if (nextIndex < 0) nextIndex = this.thumbs.length - 1;
          if (nextIndex >= this.thumbs.length) nextIndex = 0;
          this.selectThumb(this.thumbs[nextIndex]);
        });
      });

      // Opciones: flechas de scroll
      this.querySelectorAll('[data-scroll-target]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const track = document.getElementById(btn.dataset.scrollTarget);
          track?.scrollBy({ left: 120 * Number(btn.dataset.scrollDir), behavior: 'smooth' });
        });
      });

      // Opciones: selección
      this.querySelectorAll('.product-info__option-pill').forEach((pill) => {
        pill.addEventListener('click', () => this.selectOption(pill));
      });

      // Agregar al carrito
      this.addButton?.addEventListener('click', () => this.addToCart());
    }

    selectThumb(thumb) {
      this.thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (this.mainImage) this.mainImage.src = thumb.dataset.fullSrc;
      thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    selectOption(pill) {
      const index = Number(pill.dataset.optionIndex);
      const value = pill.dataset.optionValue;
      this.selectedOptions[index] = value;

      this.querySelectorAll(`.product-info__option-pill[data-option-index="${index}"]`).forEach((p) => {
        p.classList.toggle('is-active', p === pill);
      });

      const label = this.querySelectorAll('[data-selected-value]')[index];
      if (label) label.textContent = value;

      // Limpia el aviso de "falta seleccionar" de este grupo
      this.querySelectorAll('[data-option-group]')[index]?.classList.remove('is-missing');
      if (!this.querySelector('[data-option-group].is-missing')) {
        this.noticeEl?.setAttribute('hidden', '');
      }

      const match = this.variants.find((variant) =>
        variant.options.every((opt, i) => opt === this.selectedOptions[i])
      );

      if (match) {
        this.applyVariant(match);
      } else {
        // Selección incompleta o combinación inexistente: no hay variante válida todavía
        this.addButton.dataset.variantId = '';
      }
    }

    applyVariant(variant) {
      this.currentVariant = variant;
      this.addButton.dataset.variantId = variant.id;

      if (variant.available) {
        this.addButton.disabled = false;
        this.addLabel.textContent = 'Añadir al carrito';
      } else {
        this.addButton.disabled = true;
        this.addLabel.textContent = 'Agotado';
      }

      if (variant.compareAtPrice > variant.price) {
        this.priceEl.innerHTML =
          `<span class="product-info__price-compare">${this.formatMoney(variant.compareAtPrice)}</span>` +
          `<span class="product-info__price-sale">${this.formatMoney(variant.price)}</span>`;
      } else {
        this.priceEl.innerHTML = `<span>${this.formatMoney(variant.price)}</span>`;
      }

      if (this.stockEl) {
        const showStock = variant.available && variant.inventoryManagement === 'shopify' && variant.inventoryQuantity > 0;
        this.stockEl.hidden = !showStock;
        if (showStock && this.stockCountEl) this.stockCountEl.textContent = variant.inventoryQuantity;
      }

      this.maxQuantity = variant.inventoryManagement === 'shopify' ? Math.max(variant.inventoryQuantity, 1) : null;
      this.quantity = 1;
      if (this.qtyValueEl) this.qtyValueEl.textContent = '1';

      if (variant.featuredImage && this.mainImage) {
        this.mainImage.src = variant.featuredImage;
      }

      if (window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2) + ' MXN';
    }

    setupZoom() {
      const frame = this.querySelector('.product-info__main-image');
      if (!frame || !window.matchMedia('(hover: hover)').matches) return;

      frame.addEventListener('mouseenter', () => frame.classList.add('is-zoomed'));
      frame.addEventListener('mouseleave', () => {
        frame.classList.remove('is-zoomed');
        this.mainImage?.style.removeProperty('transform-origin');
      });
      frame.addEventListener('mousemove', (event) => {
        if (!this.mainImage) return;
        const rect = frame.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        this.mainImage.style.transformOrigin = `${x}% ${y}%`;
      });
    }

    changeQuantity(delta) {
      let next = this.quantity + delta;
      if (next < 1) next = 1;
      if (this.maxQuantity && next > this.maxQuantity) next = this.maxQuantity;
      this.quantity = next;
      if (this.qtyValueEl) this.qtyValueEl.textContent = String(next);
    }

    showSelectionNotice() {
      this.noticeEl?.removeAttribute('hidden');
      let first = null;
      this.querySelectorAll('[data-option-group]').forEach((group, i) => {
        if (!this.selectedOptions[i]) {
          group.classList.add('is-missing');
          first = first || group;
        }
      });
      first?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    addToCart() {
      const variantId = this.addButton.dataset.variantId;
      if (!variantId) {
        this.showSelectionNotice();
        return;
      }

      this.addButton.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: this.quantity }] }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('add-to-cart-failed');
          document.dispatchEvent(new CustomEvent('cart:items:refresh'));
          document.dispatchEvent(new CustomEvent('cart:open'));
          this.quantity = 1;
          if (this.qtyValueEl) this.qtyValueEl.textContent = '1';
        })
        .catch(() => {
          this.addLabel.textContent = 'No se pudo agregar';
          window.setTimeout(() => {
            this.addLabel.textContent = 'Añadir al carrito';
          }, 2000);
        })
        .finally(() => {
          this.addButton.classList.remove('is-loading');
        });
    }
  }

  customElements.define('product-info', ProductInfo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retail-catalog"] && !Shopify.designMode) return;
  try {
    
  class CatalogFilter extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-category]'));
      this.groups = Array.from(this.querySelectorAll('[data-category-group]'));

      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => this.selectCategory(pill.dataset.category));
      });
    }

    selectCategory(category) {
      this.pills.forEach((pill) => pill.classList.toggle('is-active', pill.dataset.category === category));
      this.groups.forEach((group) => group.classList.toggle('is-active', group.dataset.categoryGroup === category));
    }
  }

  if (!customElements.get('catalog-filter')) {
    customElements.define('catalog-filter', CatalogFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-testimonials-list]');
      this.dots = Array.from(this.querySelectorAll('[data-testimonials-dot]'));
      if (!this.list || !this.dots.length) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const card = this.list.children[Number(dot.dataset.testimonialsDot)];
          card?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index = Array.from(this.list.children).indexOf(entry.target);
                this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
              }
            });
          },
          { root: this.list, threshold: 0.6 }
        );
        Array.from(this.list.children).forEach((card) => observer.observe(card));
      }
    }
  }

  customElements.define('testimonials-carousel', TestimonialsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-catalog"] && !Shopify.designMode) return;
  try {
    
  class CatalogFilter extends HTMLElement {
    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-category]'));
      this.groups = Array.from(this.querySelectorAll('[data-category-group]'));

      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => this.selectCategory(pill.dataset.category));
      });

      this.querySelectorAll('[data-scroll-dir]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const track = this.querySelector('[data-pills-track]');
          track?.scrollBy({ left: 140 * Number(btn.dataset.scrollDir), behavior: 'smooth' });
        });
      });

      this.querySelectorAll('[data-page-btn]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const pagination = btn.closest('.wholesale-catalog__pagination');
          const grid = pagination?.previousElementSibling;
          if (!grid) return;

          const page = btn.dataset.pageBtn;

          pagination.querySelectorAll('[data-page-btn]').forEach((b) => {
            b.classList.toggle('is-active', b === btn);
          });

          grid.querySelectorAll('.wholesale-swatch').forEach((swatch) => {
            swatch.classList.toggle('is-active-page', swatch.dataset.page === page);
          });

          grid.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      });
    }

    selectCategory(category) {
      this.pills.forEach((pill) => pill.classList.toggle('is-active', pill.dataset.category === category));
      this.groups.forEach((group) => group.classList.toggle('is-active', group.dataset.categoryGroup === category));

      const activePill = this.pills.find((pill) => pill.dataset.category === category);
      activePill?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  customElements.define('catalog-filter', CatalogFilter);

  } catch(e) { console.error(e); }
})();
})();
